import React, { useEffect, useState } from "react";
import { listMetrics, getAllMetrics } from "../../../services/MetricService";
import { Center, Spinner } from "@chakra-ui/react";
import showToast from "../../../hooks/useCustomToast";
import { Header, MetricProto } from "build-ts/metadata";
import KnowledgeGraphVisualizer from "../../../components/configuration/mkg/KnowledgeGraphVisualizer";

interface ViewMKGContainerProps {
  shouldReload?: boolean; // When this is true, it triggers a reload
}

const ViewMKGContainer: React.FC<ViewMKGContainerProps> = ({ shouldReload }) => {
  const [metricList, setMetricList] = useState<Header[]>();
  const [metricInfoMap, setMetricInfoMap] = useState<Map<string, MetricProto>>(
    new Map()
  ); 
  const [loading, setLoading] = useState<boolean>(true);
  // API call to fetch all metrics
  const fetchData = async () => {
    try {
      const data = await listMetrics(""/* modelId */);
      setMetricList(data);
    } catch (error) {
      showToast("Error fetching data", "", "error");
    }
  };

  // Function to reload all data
  const reloadData = async () => {
    setLoading(true);
    setMetricInfoMap(new Map()); // Clear existing data
    await fetchData(); // This will trigger the useEffect to fetch metric list and then metricList will fetch metric info
  };

  // Fetch metric data when the component mounts
  useEffect(() => {
    fetchData();
  }, []);

  // Reload data when shouldReload is true
  useEffect(() => {
    if (shouldReload) {
      reloadData();
    }
  }, [shouldReload]);

  // Fetch data for each metric header
  useEffect(() => {
    const fetchMetricInfo = async () => {
      if (!metricList || metricList.length === 0) return;

      try {
        // Extract all metric IDs from metricList
        const metricIds = metricList.map((metricHeader) => metricHeader.id!);

        // Fetch all metrics with includeEdges=true
        const metricInfoArray = await getAllMetrics(metricIds, true);

        // Create a Map of metric data mapped by metric ID
        const dataMap = new Map<string, MetricProto>();
        metricInfoArray.forEach((metricInfo) => {
          if (metricInfo.header?.id) {
            dataMap.set(metricInfo.header.id, metricInfo);
          }
        });

        // Update state with the Map of metric data
        setMetricInfoMap(dataMap);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching metric data:", error);
      }
    };

    fetchMetricInfo();
  }, [metricList]);

  return (
    <>
      {loading ? (
        // Render a loader while loading is true
        <Center h="100vh">
          <Spinner size="xl" color="#purple.700"/>
        </Center>
      ) : (
        // Render ViewMKGNetwork component when loading is false
        // <ViewMKGNetwork
        //   metricInfoMap={metricInfoMap}
        // />
        <KnowledgeGraphVisualizer
          metricInfoMap={metricInfoMap}
        />
      )}
    </>
  );
};

export default ViewMKGContainer;
